import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { BnbaccessBoHebergementBnbaccessModule } from './hebergement/hebergement-bnbaccess.module';
import { BnbaccessBoAutorisationBnbaccessModule } from './autorisation/autorisation-bnbaccess.module';
import { BnbaccessBoAuthRequestBnbaccessModule } from './auth-request/auth-request-bnbaccess.module';
/* jhipster-needle-add-entity-module-import - JHipster will add entity modules imports here */

@NgModule({
    imports: [
        BnbaccessBoHebergementBnbaccessModule,
        BnbaccessBoAutorisationBnbaccessModule,
        BnbaccessBoAuthRequestBnbaccessModule,
        /* jhipster-needle-add-entity-module - JHipster will add entity modules here */
    ],
    declarations: [],
    entryComponents: [],
    providers: [],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class BnbaccessBoEntityModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/entity.module.ts